import { isFunction } from 'lodash'
export function getMaxHeight(maxHeight, globalMaxHeight, dialog, vm) {
  const itemMaxHeight = maxHeight && isFunction(maxHeight) ? maxHeight() : maxHeight
  const _maxHeight = itemMaxHeight || globalMaxHeight
  if (!_maxHeight && dialog) return vm.handleDialogHeight()
  return _maxHeight
}



// WEBPACK FOOTER //
// ./src/public/components/query-table/table2/config/height.js